import * as ActionType from '../../constants/actionType';

const initialState = {
  protocolName: '-',
  protocolOwner: '-',
  protocolRunBy: '-',
  summary: [],
  summaryCsv: '',
  createdTime: null,
  id: null,
  previousReport: {
    id: null,
    downloadedTime: null,
  },
};

export default function dispenseReportStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_REPORT_PROTOCOL_NAME:
      return {...state, protocolName: action.protocolName};
    case ActionType.SET_REPORT_PROTOCOL_OWNER:
      return {...state, protocolOwner: action.protocolOwner};
    case ActionType.SET_REPORT_PROTOCOL_RUN_BY:
      return {...state, protocolRunBy: action.protocolRunBy};
    case ActionType.SET_REPORT_SUMMARY:
      return {...state, summary: action.summary};
    case ActionType.SET_REPORT_SUMMARY_CSV:
      return {...state, summaryCsv: action.summary};
    case ActionType.SET_REPORT_CREATED_TIME:
      return {...state, createdTime: action.createdTime};
    case ActionType.RESTORE_REPORT_ID:
      return {...state, id: action.id};
    case ActionType.RESTORE_REPORT_SUMMARY:
      return action.state;
    case ActionType.SET_PREVIOUS_REPORT:
      return {...state, previousReport: action.report};
    default:
      return state;
  }
}
